const moduleExports = {
  DEFAULT_PAGE_TITLE: '装配式建筑PC构件库',

  APP_KEY: 'GueiWTtryvuX1MhJ26fPYzdVHDDcGMVh',
  APP_SECRET: 'p6gGFN0BF2qwFgtipDWXGhqfbIRKgTwF',
};

/* global process:true */ // 由于ESLint会检测没有定义的变量，因此需要这一个`global`注释声明IS_PRODUCTION是一个全局变量(当然在本例中并不是)来规避warning
if (process.env.NODE_ENV === 'production') {
  moduleExports.API_ROOT = 'https://frontendapi.bim.zdugroup.com/';
} else {
  moduleExports.API_ROOT = 'http://frontendapi.bim.com/';
}

export default moduleExports;



// WEBPACK FOOTER //
// ./src/config/common.config.js